module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_IT-b1b64e719627a7bddae5d4ca6c2b6112.svg";